import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {PatientResponseDTO} from '@/types/gatewayDataModels';

import {ShortPatientInfoStringState} from './stateTypes';

const initialState: ShortPatientInfoStringState = {
    patientInfo: null,
    patientInfoLoading: false,
};

const {actions, reducer} = createSlice({
    name: 'shortPatientInfoString',
    initialState,
    reducers: {
        getPatientInfo: (
            state,
            _action: PayloadAction<{
                patientId: number;
            }>,
        ) => {
            state.patientInfoLoading = true;
        },
        getPatientInfoSuccess: (state, action: PayloadAction<PatientResponseDTO>) => {
            state.patientInfo = action.payload;
            state.patientInfoLoading = false;
        },
        getPatientInfoFailed: (state) => {
            state.patientInfoLoading = false;
        },
        clearState: () => initialState,
    },
});

export const {getPatientInfo, getPatientInfoSuccess, getPatientInfoFailed, clearState} = actions;

export default reducer;
